import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalHeaderWithActions,
  ModalBody,
  ListboxSelect,
} from "@evertrue/et-components";
import {
  Form,
  JourneysFormField,
  JourneysRow,
  JourneysLabel,
  JourneysTextArea,
  JourneysInput,
} from "scripts/style/components/form";
import { getTaskTemplates } from "../../utils/api-requests/journeys-requests";

const TASK_OPTIONS = [
  { label: "Email", value: "EMAIL" },
  { label: "Phone", value: "PHONE" },
  { label: "Text", value: "TEXT" },
  { label: "Research", value: "RESEARCH" },
  { label: "Other", value: "OTHER" },
];

const JourneyTaskModal = ({
  isOpen,
  onClose,
  existingJourneyTask = {},
  editJourneyTask = () => {},
  createJourneyTask = () => {},
  journeyId,
}) => {
  const [editJourneyTaskId, setEditJourneyTaskId] = useState(
    existingJourneyTask.id
  );
  const [stepDescription, setStepDescription] = useState("");
  const [dayNumber, setDayNumber] = useState("");
  const [stepType, setStepType] = useState("");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();

  const handleSubmit = () => {
    const payload = {
      description: stepDescription,
      day_number: Number(dayNumber),
      journey_id: journeyId,
      default_action_type: stepType.value,
      task_template_id: selectedTemplate.value,
    };

    if (editJourneyTaskId) {
      editJourneyTask(payload, editJourneyTaskId);
    } else {
      const journeyTask = createJourneyTask(payload);
      setEditJourneyTaskId(journeyTask.id);
    }

    onClose();
  };

  useEffect(() => {
    const fetchTemplatesForExisting = async (journeyTaskId) => {
      const templates = await getTaskTemplates(journeyId, journeyTaskId);
      return templates.map((template) => ({
        value: template.id,
        label: template.title,
      }));
    };

    const fetchTemplates = async () => {
      const templates = await getTaskTemplates(journeyId);
      return templates.map((template) => ({
        value: template.id,
        label: template.title,
      }));
    };

    const getAndSetData = async () => {
      if (existingJourneyTask.id) {
        const {
          description = "",
          day_number = "",
          task_template_id,
          default_action_type = "",
        } = existingJourneyTask;

        const templatesFromApi = await fetchTemplatesForExisting(
          existingJourneyTask.id
        );
        const selected = templatesFromApi.find(
          (template) => template.value === task_template_id
        );
        const selectedType = TASK_OPTIONS.find(
          (option) => option.value === default_action_type
        );

        setSelectedTemplate(selected);
        setTemplates(templatesFromApi);
        setStepDescription(description);
        setDayNumber(day_number);
        setStepType(selectedType);
      } else {
        const templatesFromApi = await fetchTemplates();
        setTemplates(templatesFromApi);
      }
    };

    getAndSetData();
  }, [existingJourneyTask, journeyId]);

  const handleTitleSelect = (value) => {
    setSelectedTemplate(value);
  };

  const handleStepTypeSelect = (value) => {
    setStepType(value);
  };

  return (
    <Modal isOpen={isOpen} closeModal={onClose} width={568}>
      <ModalHeaderWithActions
        title={editJourneyTaskId ? "Edit Step" : "Add Step"}
        submitLabel={editJourneyTaskId ? "Update" : "Create"}
        closeModal={onClose}
        onSubmit={handleSubmit}
      />
      <ModalBody>
        <Form>
          <JourneysRow>
            <JourneysFormField>
              <JourneysLabel htmlFor="display-name">Step Name</JourneysLabel>
              <ListboxSelect
                label="Step Name"
                emptyValue="Select Title"
                options={templates}
                onChange={handleTitleSelect}
                value={selectedTemplate}
              />
            </JourneysFormField>
            <JourneysFormField>
              <JourneysLabel htmlFor="field-type">Description</JourneysLabel>
              <JourneysTextArea
                onChange={({ target: { value } }) => setStepDescription(value)}
                id="cadence-description"
                value={stepDescription}
              />
            </JourneysFormField>
            <JourneysFormField>
              <JourneysLabel htmlFor="display-name">Step Type</JourneysLabel>
              <ListboxSelect
                label="Step Type"
                emptyValue="Select Type"
                options={TASK_OPTIONS}
                onChange={handleStepTypeSelect}
                value={stepType}
              />
            </JourneysFormField>
            <JourneysFormField>
              <JourneysLabel htmlFor="display-name">Day Number</JourneysLabel>
              <JourneysInput
                type="text"
                onChange={({ target: { value } }) => setDayNumber(value)}
                name="name"
                value={dayNumber}
                style={{
                  width: "10%",
                }}
              />
            </JourneysFormField>
          </JourneysRow>
        </Form>
      </ModalBody>
      <div
        style={{
          paddingRight: "40px",
          paddingBottom: "20px",
          float: "right",
        }}
      ></div>
    </Modal>
  );
};

JourneyTaskModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  existingJourneyTask: PropTypes.object,
  editJourneyTask: PropTypes.func,
  createJourneyTask: PropTypes.func,
  journeyId: PropTypes.number,
};

JourneyTaskModal.defaultProps = {
  existingJourneyTask: {},
  editJourneyTask: () => {},
  createJourneyTask: () => {},
  journeyId: null,
};

export default JourneyTaskModal;
